import { Box, CircularProgress, Typography } from "@mui/material"
import { t } from "i18next"
import React from "react"
import { useJobContext } from "../../contexts/JobContext"
import { useBulkUpdateStatusHook } from "../../entities/job/helper"
import { EJobStatus, IJob } from "../../entities/job/interface"
import JobAnimatedAddress from "../JobAnimatedAddress"
import { theme } from "../../styles/theme"

interface IAtLocationProps {
    updateJobStatus: (status: EJobStatus) => void
    jobStatus: EJobStatus
    address: string
    company: string
    isNotAtLocation?: string
    stage: string
    stageAction: string
    onStatusUpdate?: (status: EJobStatus) => void // ✅ Callback function prop
    currentMapState?: boolean
}

//to be put in job component
const AtLocation: React.FC<IAtLocationProps> = ({
    jobStatus,
    address,
    company,
    isNotAtLocation,
    stage,
    stageAction,
    currentMapState,
}) => {
    const { currentJobs, setCurrentJobStatus } = useJobContext()
    // const { handleJobUpdate, jobUpdateMutationLoading } = useUpdateStatusHook()
    const { handleBulkJobsUpdate, loading } = useBulkUpdateStatusHook()

    const handleJobAtLocation = (jobs: IJob[]) => {
        try {
            const jobIds = jobs.filter((job) => !job.isJobCompleted).map((job) => job._id)
            if (jobIds.length === 0) return

            // Update all jobs to the next status
            handleBulkJobsUpdate(jobIds, jobStatus)

            // Set the selected job in the context
            setCurrentJobStatus(jobStatus)
        } catch (error) {
            // Handle error: open modal with error message
            console.error(error)
        }
    }

    if (!currentJobs) {
        return <CircularProgress color="secondary" />
    }

    return (
        <>
            <JobAnimatedAddress instruction={"Arrived At"} title={address} content={company} />
            <Box
                position={"absolute"}
                width={"90vw"}
                maxWidth={700}
                display={"flex"}
                alignItems={"center"}
                bgcolor={currentMapState ? theme.palette.success.main : theme.palette.error.main}
                alignSelf={"center"}
                flexDirection={"column"}
                borderRadius={6}
                padding={"2%"}
                paddingY={3}
                textAlign={"center"}
                bottom={"11vh"}
                onClick={() => handleJobAtLocation(currentJobs)}
                marginBottom={6}
            >
                {loading ? (
                    <CircularProgress color="secondary" /> // Show loader when mutation is loading
                ) : (
                    <>
                        <Typography variant="h6" color="#fff">
                            {t("jobs.mobile.atLocation.title", { stage, isNotAtLocation })}
                        </Typography>
                        <Typography
                            sx={{
                                color: "#fff",
                                fontSize: "12px",
                                fontWeight: "bold",
                                textAlign: "center",
                                letterSpacing: "0.1em",
                                fontFamily: theme.typography.fontFamily, // Using font from theme
                            }}
                        >
                            {t("jobs.mobile.atLocation.subTitle", { stageAction })}
                        </Typography>
                    </>
                )}
            </Box>
        </>
    )
}

export default AtLocation
